import { CSSProperties, FunctionComponent, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { faSidebar } from "@fortawesome/pro-regular-svg-icons";

import { translationKeys } from "../../../../models/app-translation-keys";
import { useStore } from "../../../../stores/StoreContext";
import { ActionButton } from "../../Buttons";

interface ISidebarToggleButtonProps {
  hide?: boolean;
  onClick: () => void;
}

const RawSidebarToggleButton: FunctionComponent<ISidebarToggleButtonProps> = (props: ISidebarToggleButtonProps) => {
  const { t, i18n } = useTranslation();
  const { sidebarStore, breakpointStore } = useStore();

  const isExpanded = !sidebarStore.isCollapsed || sidebarStore.isOverlaySidebarVisible;

  const tooltipTranslationMemo = useMemo(
    () => (isExpanded ? t(translationKeys.tooltip.hideSidebar) : t(translationKeys.tooltip.showSidebar)),
    [isExpanded, i18n.language],
  );

  if (props.hide) {
    return null;
  }

  return (
    <ActionButton
      id="sidebar-toggle-button"
      icon={faSidebar}
      onClick={props.onClick}
      tooltip={tooltipTranslationMemo}
      tooltipDisabled={breakpointStore.device === "mobile"}
    />
  );
};

export const SidebarToggleButton = observer(RawSidebarToggleButton);
